import apiClient, { optionalParams } from "@/services/apiClient";

/**
 * @typedef {Object} Magazine
 * @property {string} category - Categoria dell'articolo
 * @property {string} pic - URL immagine di copertina
 * @property {string} date - Data di pubblicazione
 * @property {string} title - Titolo dell'articolo
 * @property {string} abstract - Testo di anteprima dell'articolo
 * @property {string} author - Nome dell'autore
 * @property {string} link - URL dell'articolo
 */

export const SiteService = {
  /**
   * Recupera gli articoli dal feed RSS del sito.
   * @param {Object} [params]
   * @param {number} [params.limit=1] - Numero massimo di articoli da restituire
   * @returns {Promise<{data: Magazine[]|null, error: string|null}>}
   */
  async getMagazines({ limit = 1 } = {}) {
    try {
      const query = optionalParams({ limit });
      const { data } = await apiClient.get("front/v1/site-rss", {
        params: query,
      });
      return { data, error: null };
    } catch (e) {
      return { data: null, error: e.userMessage ?? e.message };
    }
  },
};